// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "./application"
import AccreditationFormController from "./accreditation_form_controller"
import CapitalCallFormController from "./capital_call_form_controller"
import AgreementScrollController from "./agreement_scroll_controller"
import ColumnPreferencesController from "./column_preferences_controller"
import ConversionFormController from "./conversion_form_controller"
import DocumentUploadController from "./document_upload_controller"
import FlashController from "./flash_controller"
import FundContractsFormController from "./fund_contracts_form_controller"
import FundInvestorsFormController from "./fund_investors_form_controller"
import FundPartnersFormController from "./fund_partners_form_controller"
import InvestmentFormController from "./investment_form_controller"
import InvestorInfoFormController from "./investor_info_form_controller"
import MarkFormController from "./mark_form_controller"
import ModalController from "./modal_controller"
import MultistepFormController from "./multistep_form_controller"
import PasswordValidationController from "./password_validation_controller"
import PositionFormController from "./position_form_controller"
import PaymentMethodsController from "./payment_methods_controller"
import PlanPeriodController from "./plan_period_controller"
import SearchController from "./search_controller"
import SidebarPreferencesController from "./sidebar_preferences_controller"
import SignaturePadController from "./signature_pad_controller"
import SortableTableController from "./sortable_table_controller"
import StagingBannerController from "./staging_banner_controller"
import TabsPersistenceController from "./tabs_persistence_controller"
import ThemePreviewController from "./theme_preview_controller"
import UnderlyingFundInvestmentFormController from "./underlying_fund_investment_form_controller"
import UnderlyingFundTransactionFormController from "./underlying_fund_transaction_form_controller"
import UtilsController from "./utils_controller"
import "@37signals/lexxy"

application.register("accreditation-form", AccreditationFormController)
application.register("agreement-scroll", AgreementScrollController)
application.register("capital-call-form", CapitalCallFormController)
application.register("column-preferences", ColumnPreferencesController)
application.register("conversion-form", ConversionFormController)
application.register("document-upload", DocumentUploadController)
application.register("flash", FlashController)
application.register("fund-contracts-form", FundContractsFormController)
application.register("fund-investors-form", FundInvestorsFormController)
application.register("fund-partners-form", FundPartnersFormController)
application.register("investment-form", InvestmentFormController)
application.register("investor-info-form", InvestorInfoFormController)
application.register("mark-form", MarkFormController)
application.register("modal", ModalController)
application.register("multistep-form", MultistepFormController)
application.register("password-validation", PasswordValidationController)
application.register("payment-methods", PaymentMethodsController)
application.register("plan-period", PlanPeriodController)
application.register("position-form", PositionFormController)
application.register("search", SearchController)
application.register("sidebar-preferences", SidebarPreferencesController)
application.register("signature-pad", SignaturePadController)
application.register("sortable-table", SortableTableController)
application.register("staging-banner", StagingBannerController)
application.register("tabs-persistence", TabsPersistenceController)
application.register("theme-preview", ThemePreviewController)
application.register("underlying-fund-investment-form", UnderlyingFundInvestmentFormController)
application.register("underlying-fund-transaction-form", UnderlyingFundTransactionFormController)
application.register("utils", UtilsController)
